<br>
<div class="row">
    <div class="col-sm-12">
        <div style="width: 100%;">
            <table mat-table matSort matSortActive="createdDate" matSortDirection="desc" matSortDisableClear [dataSource]="dataSource" style="width: 100%;">
                <ng-container matColumnDef="createdDate">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> Date </th>
                    <td mat-cell *matCellDef="let element"> {{element.createdDate | date:'MM/dd/yyyy hh:mm a'}} </td>
                </ng-container>
                <ng-container matColumnDef="createdBy">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> User ID </th>
                    <td mat-cell *matCellDef="let element">{{element.createdBy}}</td>
                </ng-container>
                <ng-container matColumnDef="description">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let element">{{element.description}}</td>
                </ng-container>
                <ng-container matColumnDef="sportSeason">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> Sport Season </th>
                    <td mat-cell *matCellDef="let element"> {{element.sportSeason}} </td>
                </ng-container>
                <ng-container matColumnDef="sportType">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> Sport Type </th>
                    <td mat-cell *matCellDef="let element"> {{element.sportType}} </td>
                </ng-container>
                <ng-container matColumnDef="newValue">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> New Value </th>
                    <td mat-cell *matCellDef="let element"> {{element.newValue}} </td>
                </ng-container>
                <ng-container matColumnDef="previousValue">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> Previous Value </th>
                    <td mat-cell *matCellDef="let element"> {{element.previousValue}} </td>
                </ng-container>
                <ng-container matColumnDef="institutionTerm">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> Institution Term </th>
                    <td mat-cell *matCellDef="let element"> {{element.institutionTerm}} </td>
                </ng-container>
                <ng-container matColumnDef="financialAidType">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> Financial Aid Type </th>
                    <td mat-cell *matCellDef="let element"> {{element.financialAidType}} </td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row matRipple  *matRowDef="let row; columns: displayedColumns;" ></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[20, 30, 50]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>
